/* tslint:disable:no-empty */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function noop() { }
//# sourceMappingURL=noop.js.map 



//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/rxjs/_esm5/util/noop.js
// module id = PR+T
// module chunks = 1 2